import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from "react-router-dom";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import Context from "context/context";
import Tables from "components/table/table";
import taskAPI from "apis/panel/task/task";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 500,
    cursor: "pointer",
    backgroundColor: "#002c5d",
    color: "#ffffff",
  },
});

const TaskSetup = () => {
  const { state, dispatch } = useContext(Context);
  const [roleCode] = useState(state.role.roleCode);
  const navigate = useNavigate();  
  const { getAllMasterTasks } = taskAPI();
  const [taskDetails, settaskDetails]= useState([]);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [serialNumber, setSerialNumber] = useState("");

  useEffect(() => {
    handleGetAllrole();    
  }, [offset, searchValue, filterValue]);

  const handleGetAllrole = async () => {
    try {
      dispatch({ type: "SET_LOADING", payload: true });
      let values;
      values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };
      if (searchValue) {
        values = {
          ...values,
          searchValue,
        };
      }
      if (filterValue) {
        values = {
          ...values,
          filterValue,
        };
      }
      let res = await getAllMasterTasks(values);
      settaskDetails(res?.data?.tasks || []);
      setCount(res?.data?.count);
      setSerialNumber(offset)
      dispatch({ type: "SET_LOADING", payload: false });
    } 
    catch (err) {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  return (
    <div style={{backgroundColor:"white", borderRadius:"10px"}}>
      <Tables
        role={roleCode}
        title={
          <Box className="EmployeeRoster" sx={{ pt:2, pb:2, pl:2}}>Task Information</Box>
        }
        searchBar={true}
        setSearchValue={setSearchValue}
        filter={true}
        filterValue={filterValue}
        setFilterValue={setFilterValue}
        filterValues={[
          { label: "Task Id", value: "" },
          { label: "Task Name", value: "taskName" }
        ]}

        create={
          <Button 
            className="AddEmployerButton" 
            onClick={(e) =>
              navigate("../AddTask")
            }
          >
            New Task
          </Button>
        }
        heading={[
          "S.No",
          "Task Id",
          "Task Name",
          "Project Type",
          "Cost Center",
          "Status",
          "Action"
        ]}
        data={taskDetails?.map((task, index) => [
          index + 1 + (serialNumber - 1) * 10,
          task.taskCode,
          task.taskName,
          task.projectTypes.projectTypeName,
          task.costCenter,
          <span style={{ color: task.status === 'Active' ? 'green' : task.status === 'Onhold' ? 'black' : 'red', fontWeight: 700, fontSize: '14px' }}>
            {task.status === 'Active' ? ' Active' : task.status === 'Onhold' ? ' Onhold' : ' Inactive'}
          </span>,        
          <CustomWidthTooltip
          title='Click to view details'
        >  
          <span className="jobType">            
            <RemoveRedEyeIcon 
              style={{ color: "#FE602F", cursor: "pointer" }} 
              onClick={(e) =>
                navigate("../EditTask/"+task.taskId)
              } 
            />
          </span>
          </CustomWidthTooltip>
        ])}
        offset={offset}
        setOffset={setOffset}
        count={count}
        placeholder="Search by Task ID & Task Name"
      />
    </div>   
  )
}

export default TaskSetup;